import React from "react";
import { deBaseAFechaLocal } from "../../utils/Tools.js";

const CuadroResumen = ({ reserva = {} }) => {
  const moneda = reserva.producto.moneda.codigoMoneda !== "PES" ? "U$D" : "$";
  //FC: descomentar cuando se use pesos
  /*
  const total = (reserva.totalReserva * reserva.producto.moneda.cotizacion).toFixed(2);
  const saldo = (reserva.saldo * reserva.producto.moneda.cotizacion).toFixed(2);
*/

  return (
    <div className="tabla-reservas col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
      <table id="tablaReservas" className="display">
        <thead>
          <tr>
            <th>Nombre</th>
            <th>N° Reserva</th>
            <th>Fecha</th>
            <th>Total</th>
            <th>Saldo</th>
            <th>Cotizacon</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{reserva.producto.destino.descripcion}</td>
            <td>{reserva.numeroReserva}</td>
            <td>{deBaseAFechaLocal(reserva.charter.fechaSalida)}</td>
            <td>
              {moneda} {reserva.totalReserva}
            </td>
            <td>
              {moneda} {reserva.saldo}
            </td>
            <td>
              {reserva.producto.moneda.codigoMoneda}{" "}
              {reserva.producto.moneda.cotizacion}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default CuadroResumen;



// WEBPACK FOOTER //
// ./src/components/MisReservas/CuadroResumen.js